import api from '@/libs/axios'

const resource = 'Fichiers'

export default class FichierResource { 
  // public async downloadFile(fileId: string) : Promise<any> {
  //   const response = await api.get(`${resource}/askDownload?fileId=${fileId}`)
  //   return response.data
  // }
}